import './Intro.css';

// Vendors
import React from 'react';
import {CSSTransition} from 'react-transition-group';

import STATUS from '../Game/constants';

import Instruction, {Container as InstructionsContainer} from '../../shared/Instruction';

// Assets
import greenBubble from './svg/Correct_GreenBubble.svg';
import redBubble from './svg/Error_RedBubble.svg';

/**
 * Intro
 */
export default function Intro(props) {
  return (
    <CSSTransition
      in={props.status === STATUS.INTRO_DEMO}
      timeout={350}
      classNames="fade"
      unmountOnExit
    >
      <div>
        <div className="Intro col-12 flex flex--justify-sb flex--align-c">
          <div className="Intro-col">
            <img className={props.incorrectClass} src={redBubble} alt="Incorrect"/>
          </div>
          <div className="Intro-col">
            <img className={props.correctClass} src={greenBubble} alt="Correct"/>
          </div>
        </div>
        <InstructionsContainer style={{margin: '0 1rem'}}>
          <Instruction visible={props.instructionStep === 1} wasVisible={props.instructionStep > 1}>
            If the behaviour is positive, drag the card to the positive pile.
          </Instruction>
          <Instruction visible={props.instructionStep === 2} wasVisible={props.instructionStep > 2}>
            If the behaviour is negative, drag the card to the negative pile.
          </Instruction>
          <Instruction visible={props.instructionStep === 3} wasVisible={props.instructionStep > 3}>
            Match all the cards to their correct behaviour to end the game.
          </Instruction>
        </InstructionsContainer>
      </div>
    </CSSTransition>
  )
}



// WEBPACK FOOTER //
// ./src/components/rlgl/Intro/Intro.js